export default __webpack_public_path__ + "static/media/nbt.e32c1ef0.jsworker";